import React, { useState } from "react";

const RegdState = ({ onSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  // const [selectedSub, setSelectedSub] = useState(null);

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry",
    "Jammu and Kashmir",
    "Ladakh",
  ];

  // const subSelections = [
  //   "st-01",
  //   "st-02",
  //   "st-03",
  //   "st-04",
  //   "st-05",
  //   "st-06",
  //   "st-07",
  //   "st-08",
  //   "st-09",
  //   "st-10",
  //   "st-11",
  //   "st-12",
  //   "st-13",
  //   "st-14",
  //   "st-15",
  //   "st-16",
  //   "st-17",
  //   "st-18",
  //   "st-19",
  //   "st-20",
  //   "st-21",
  //   "st-22",
  //   "st-23",
  //   "st-24",
  //   "st-25",
  //   "st-26",
  //   "st-27",
  //   "st-28",
  //   "st-29",
  //   "st-30",
  //   "st-31",
  //   "st-32",
  //   "st-33",
  //   "st-34",
  //   "st-35",
  //   "st-36",
  //   "st-37",
  //   "st-38",
  //   "st-39",
  //   "st-40",
  //   "st-41",
  //   "st-42",
  //   "st-43",
  //   "st-44",
  //   "st-45",
  //   "st-46",
  //   "st-47",
  //   "st-48",
  //   "st-49",
  //   "st-50",
  //   "st-51",
  // ];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleStateSelect = (state) => {
    setSelectedState(state);
    onSelect("state", state)
    // setSelectedSub(null);
  };

  // const handleSubSelect = (sub) => {
  //   if (selectedState) {
  //     const data = {
  //       state: selectedState,
  //       subSelection: sub,
  //     };
  //     setSelectedSub(sub); // Set selected sub for confirmation
  //     onSelect("regdStateSelection", data);
  //   }
  // };

  const filteredStates = states.filter((state) =>
    state.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // const filteredSubSelections = subSelections.filter((sub) =>
  //   sub.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  return (
    <>
      <section
        style={{
          fontFamily: "Ballega",
          height: "40rem",
          maxHeight: "90vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="overflow-y-auto"
      >
        <h4 className="text-center text-3xl mb-8">
          {/* {selectedState
            ? selectedState
            : selectedSub
            ? `Sub-selection: ${selectedSub}`
            : "Select the Reg. state"} */}
        </h4>

        <div className="relative mb-8 flex justify-center items-center">
          <input
            type="search"
            placeholder="SEARCH FOR THE BRAND"
            aria-label="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full px-4 py-4 text-center placeholder-gray font-bold text-lg border border-black rounded-lg text-sm focus:ring focus:ring-black-200 focus:outline-none"
          />
          <span className="absolute right-8 sm:right-52 lg:right-96 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-5 h-5 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M9 16a7 7 0 100-14 7 7 0 000 14z"
              />
            </svg>
          </span>
        </div>
        <h4 className="text-3xl mb-8">Select the type of Fuel</h4>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8 my-12 sm:px-32">
          {filteredStates.map((state) => (
            <button
              key={state}
              className={`border border-black p-1 sm:p-2 md:p-4 text-normal sm:text-md md:text-2xl rounded-md ${
                selectedState === state ? "bg-sky-500 text-white" : ""
              }`}
              onClick={() => handleStateSelect(state)}
            >
              {state}
            </button>
          ))}
        </div>
        {/* {!selectedState && !selectedSub ? (
          <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 my-12 sm:px-32">
            {filteredStates.map((state) => (
              <button
                key={state}
                className={`border border-black p-4 text-normal sm:text-3xl lg:text-4xl rounded-md ${
                  selectedState === state ? "bg-sky-500 text-white" : ""
                }`}
                onClick={() => handleStateSelect(state)}
              >
                {state}
              </button>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 my-12 sm:px-6">
            {filteredSubSelections.map((sub) => (
              <button
                key={sub}
                className="border border-black p-4 text-normal sm:text-3xl lg:text-4xl rounded-md"
                onClick={() => handleSubSelect(sub)}
              >
                {sub}
              </button>
            ))}
          </div>
        )} */}
      </section>
    </>
  );
};

export default RegdState;
